import { useMemo } from "react";
import { useUser } from "../context/UserConext";
import { CUPOS_SUBNAV, type MenuItem } from "../types/menu.types";
import {
  Home as HomeIcon,
  People as UsersIcon,
  Terminal as TerminalIcon,
  ShoppingCart,
} from "@mui/icons-material";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import InventoryIcon from "@mui/icons-material/Inventory";
import BusinessIcon from "@mui/icons-material/Business";
import WarehouseIcon from "@mui/icons-material/Warehouse";
import ReportIcon from "@mui/icons-material/Report";
import PieChartOutlinedIcon from "@mui/icons-material/PieChartOutlined";

const useMenuHook = () => {
  const { user } = useUser();

  const menu = useMemo((): MenuItem[] => {
    const localMenu: MenuItem[] = [
      { text: "Inicio", icon: <HomeIcon />, path: "/home" },
    ];

    const permissions = user?.user?.permission ?? [];
    const hasPermission = (...requiredPermissions: string[]) =>
      requiredPermissions.some((permission) =>
        permissions.includes(permission),
      );

    if (hasPermission("CRUD_COMPANIES", "VIEW_ADMIN")) {
      localMenu.push({
        text: "Sociedades",
        icon: <BusinessIcon />,
        path: "/societies",
      });
    }

    if (hasPermission("CRUD_USERS", "VIEW_ADMIN")) {
      localMenu.push({
        text: "Usuarios",
        icon: <UsersIcon />,
        path: "/users",
      });
    }

    if (hasPermission("VIEW_LOGS", "VIEW_ADMIN")) {
      localMenu.push({
        text: "Logs",
        icon: <TerminalIcon />,
        path: "/logs",
      });
    }

    if (hasPermission("VIEW_CLIENTS", "VIEW_ADMIN")) {
      localMenu.push({
        text: "Clientes",
        icon: <PersonAddIcon />,
        path: "/clients",
      });
    }

    if (hasPermission("VIEW_PRODUCTS", "VIEW_ADMIN")) {
      localMenu.push({
        text: "Productos",
        icon: <InventoryIcon />,
        path: "/products/",
      });
    }

    if (hasPermission("CRUD_STOCK", "VIEW_ADMIN")) {
      localMenu.push({
        text: "Stock",
        icon: <WarehouseIcon />,
        path: "/stock",
      });
    }

    if (hasPermission("CLIENT")) {
      localMenu.push({
        text: "Pedidos",
        icon: <ShoppingCart />,
        path: "/orders",
      });
    }

    if (hasPermission("VIEW_ADMIN")) {
      localMenu.push({
        text: "Exportar pedidos",
        icon: <ShoppingCart />,
        path: "/orders/tango",
      });
    }

    if (hasPermission("VIEW_REPORTS", "VIEW_ADMIN")) {
      localMenu.push({
        text: "Reportes",
        icon: <ReportIcon />,
        path: "/reports",
      });
    }

    if (hasPermission("CRUD_CLASSIFICATION", "VIEW_ADMIN")) {
      localMenu.push({
        text: "Cupos",
        icon: <PieChartOutlinedIcon />,
        path: "/cupos/producto",
        subNav: CUPOS_SUBNAV,
      });
    }

    return localMenu;
  }, [user]);

  return { menu };
};

export default useMenuHook;
